import { io } from "socket.io-client";

// "undefined" means the URL will be computed from the `window.location` object
const URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:43000"
    : process.env.REACT_APP_CREATELY_AI_SVC;

export const joinSocket = (channelId) => io(URL, { query: { channelId } });
